import { render } from "./StoryBlocks.vue?vue&type=template&id=7bc4c051&scoped=true"
import script from "./StoryBlocks.vue?vue&type=script&lang=js"
export * from "./StoryBlocks.vue?vue&type=script&lang=js"

import "./StoryBlocks.vue?vue&type=style&index=0&id=7bc4c051&scoped=true&lang=css"

import exportComponent from "/builds/site-palette/palette.site-new/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7bc4c051"]])

export default __exports__